import React, { useState, type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  LINK_VARIANT_HIGHLIGHT,
  Link,
  MESSAGE_BOX_VARIANT_HELP,
  MessageBox,
} from 'mailup-web-components'

import {
  STORE_KEY_ACCOUNT_DATA_RETENTION,
  storeGet,
} from 'mailup-react-helpers'

import ModalExtendStatisticsDataPromo from 'Components/ModalExtendStatisticsDataPromo'
import { STORE_KEY_ACCOUNT, offerType } from 'Constants'
import { isEcommerceVisible } from 'Helpers/ecommerce'

interface DataRetentionMessageProps {
  channel: 'email' | 'sms'
}

const DataRetentionMessage: FC<DataRetentionMessageProps> = ({ channel }) => {
  const intl = useIntl()
  const DataRetention = storeGet(STORE_KEY_ACCOUNT_DATA_RETENTION)
  const accountDetails = storeGet(STORE_KEY_ACCOUNT)
  const isMshopLinkVisible: boolean =
    (isEcommerceVisible() &&
      (accountDetails.IdOffer === offerType.StarterEdition ||
        accountDetails.IdOffer === offerType.LightEdition)) ||
    accountDetails.IdOffer === offerType.Frequenza
  const [show, setShow] = useState(false)

  if (channel === 'sms') {
    return null
  }

  const openPromoModal = (): void => {
    setShow(true)
  }

  const handlePromoClose = (): void => {
    setShow(false)
  }

  return (
    <>
      <ModalExtendStatisticsDataPromo show={show} onCancel={handlePromoClose} />
      <MessageBox variant={MESSAGE_BOX_VARIANT_HELP}>
        {intl.formatMessage(
          { id: 'Load.ActiveRecipientSummary.InfoDataRetention' },
          {
            strong: (chunks) => <strong>{chunks}</strong>,
            x: DataRetention,
          },
        )}{' '}
        {isMshopLinkVisible &&
          intl.formatMessage(
            { id: 'Load.Statistics.ExtensionDataAvailability' },
            {
              a: (chunks) => (
                <Link variant={LINK_VARIANT_HIGHLIGHT} onClick={openPromoModal}>
                  {chunks}
                </Link>
              ),
            },
          )}
      </MessageBox>
    </>
  )
}

export default DataRetentionMessage
